<template>
    <div id="eraser-tool-options"
         class="tool-options"
    >
        <div class="size-selector-container">
             <size-selector></size-selector>
        </div>
        <a id="btn-erase-all"
           @click.prevent="eraseAll"
           :title="i18n.t('tooltip_clear_all')"
           href="#">
        </a>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch,inject}  from "vue"
    import SizeSelector from "@/views/reader/tool/SizeSelector";
    import {eraseAll} from "@/modules/reader/tools/drawing/eraserTool";

    export default {
        components: {
            SizeSelector
        },
        setup(props, context) {

            const i18n = inject('i18n');

            return {
                i18n,
                eraseAll
            }
        }
    }

</script>

<style scoped lang="scss">

    #eraser-tool-options {
        width:62px;
        left:126px;
    }

    #btn-erase-all{
        background:url("~images/icon_clear_all.svg");
        background-size:38px 38px;
        width:38px;
        height:38px;
        display:block;
        margin:$tool-icon-margin;
        border: 2px solid #fff;
        &:hover {
            border: 2px solid $color-primary;
        }
    }

    .size-selector-container {
        @include tool-seperator(bottom);
    }

</style>